import { useTranslation } from 'react-i18next';

import PageLayout from '~layouts/page/pageLayout';

import WebhooksOverviewContainer from '../containers/webhooksOverviewContainer';

const WebhookPage = () => {
	const { t } = useTranslation();
	return (
		<PageLayout
			pageTitle={t('webhook.labels.plural', { ns: 'entities' })}
			headerInfo={{
				title: t('webhook.labels.plural', { ns: 'entities' }),
			}}
		>
			<WebhooksOverviewContainer />
		</PageLayout>
	);
};

export default WebhookPage;
